import { client as elevioClient } from 'elevio';
import { useEffect } from 'react';

export type IntelligenceElevioEvents = {
  /**
   * Open an Elevio article.
   *
   * @param arg.id Elevio article ID.
   */
  'elevio:openArticle': (arg: { id: string }) => void;
};

export const useIntelligenceElevioEvents = (): void => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const { appEvents } = window._intelligence;

    appEvents.on('elevio:openArticle', ({ id }) => {
      if (!id) return;

      elevioClient.openArticle(id);
    });
  }, []);
};
